export const apiUrl = "/api/";